import { presetRange, type Range } from "@/lib/periodo";

export function DateRangePicker({ value, onChange }: { value: Range; onChange: (r: Range) => void }) {
  return (
    <div className="flex flex-wrap gap-2 items-center">
      <div className="flex items-center gap-1.5 text-sm">
        <span className="text-muted-foreground">Da</span>
        <input type="month" value={value.from}
          onChange={(e) => onChange({ ...value, from: e.target.value })}
          className="px-2.5 py-2 border border-border rounded-lg bg-card" />
        <span className="text-muted-foreground">a</span>
        <input type="month" value={value.to}
          onChange={(e) => onChange({ ...value, to: e.target.value })}
          className="px-2.5 py-2 border border-border rounded-lg bg-card" />
      </div>
      <select onChange={(e) => { if (e.target.value) onChange(presetRange(e.target.value as "corrente" | "3" | "6" | "12" | "ytd")); }}
        className="px-2.5 py-2 border border-border rounded-lg text-sm bg-card text-muted-foreground" defaultValue="">
        <option value="">Preset…</option>
        <option value="corrente">Mese corrente</option>
        <option value="3">Ultimi 3 mesi</option>
        <option value="6">Ultimi 6 mesi</option>
        <option value="12">Ultimi 12 mesi</option>
        <option value="ytd">Anno corrente</option>
      </select>
    </div>
  );
}
